import { createSelector } from 'reselect'

const getServiceName = (state, serviceName) => {
  return serviceName
}

const getRoles = (state, serviceName) => {
  if (state.login) {
    const { roles } = state.login
    return roles
  } else {
    return null
  }
}

const checkServicePermission = (serviceName, roles) => {
  const projects =
    roles['https://auth0.looknorthservices.com/v1/permissions'].coresight2
      .projects
  const layers = Object.keys(projects).map(key => projects[key].layers)
  const merged = [].concat.apply([], layers.map(layer => Object.keys(layer)))
  const match = merged.find(
    service => service.toLowerCase() === serviceName.toLowerCase()
  )

  return !!match
}

export const makeGetPermission = () => {
  return createSelector([getRoles, getServiceName], (roles, serviceName) => {
    try {
      return checkServicePermission(serviceName, roles)
    } catch (error) {
      return false
    }
  })
}



// WEBPACK FOOTER //
// ./src/selectors/permissionSelector.js